module.exports = __webpack_public_path__ + "static/04df0579-f419-41e6-8806-f1139595598b-51633212660af14feffd79e48dfb8c78.webp";